
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-mock-test",
      function () {
        return require("private-next-pages/my-mock-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-mock-test"])
      });
    }
  